import { Subscription } from "rxjs";

import { LoaderService } from "../../_services/loader.service";
import { ILoaderState } from "../../_models/ILoaderState";

import { Component, OnInit, ViewChild, TemplateRef, ViewContainerRef, DoCheck, OnDestroy } from "@angular/core";
import { OverlayRef } from "@angular/cdk/overlay";

import { OverlayService, IAppOverlayConfig } from "../../app.overlay.module";

@Component({
    selector: "app-loader",
    templateUrl: "loader.component.html",
    styleUrls: ["loader.component.css"]
})
export class LoaderComponent implements OnInit, DoCheck, OnDestroy {
    backdropEnabled = true;
    positionGloballyCenter = true;
    show = false;

    @ViewChild("progressSpinnerRef", {static: true})
    private progressSpinnerRef: TemplateRef<any>;
    private progressSpinnerOverlayConfig: IAppOverlayConfig;
    private overlayRef: OverlayRef;
    private subscription: Subscription;

    constructor(private vcRef: ViewContainerRef, private overlayService: OverlayService, private loaderService: LoaderService) { }

    ngOnInit() {
        // Config for Overlay Service
        this.progressSpinnerOverlayConfig = {
            hasBackdrop: this.backdropEnabled
        };

        if (this.positionGloballyCenter) {
            this.progressSpinnerOverlayConfig["positionStrategy"] = this.overlayService.positionGloballyCenter();
        }

        // Create Overlay for progress spinner
        this.overlayRef = this.overlayService.createOverlay(this.progressSpinnerOverlayConfig);

        this.subscription = this.loaderService.loaderState
            .subscribe((state: ILoaderState) => {
                this.show = state.show;

                if (this.show && !this.overlayRef.hasAttached()) {
                    this.overlayService.attachTemplatePortal(this.overlayRef, this.progressSpinnerRef, this.vcRef);
                } else if (!this.show && this.overlayRef.hasAttached()) {
                    this.overlayRef.detach();
                }
            });
    }

    ngDoCheck() {
        //// Based on status of displayProgressSpinner attach/detach overlay to progress spinner template
        //if (this.show && !this.overlayRef.hasAttached()) {
        //    this.overlayService.attachTemplatePortal(this.overlayRef, this.progressSpinnerRef, this.vcRef);
        //} else if (!this.show && this.overlayRef.hasAttached()) {
        //    this.overlayRef.detach();
        //}
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}